module.exports = __webpack_public_path__ + "static/img/5983_phase_function_Paper_PointsHejduk_Prediction.66169b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5983_phase_function_Paper_PointsHejduk_Prediction.png
// module id = TuHm
// module chunks = 0